<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <!-- sidebar -->
    <sidebar></sidebar>
    <a-layout>
      <a-layout-content :style="{ margin: '16px', padding: '24px', minHeight: '100vh' }">
        <a-row :style="{margin:'5px'}">
          <a-col :span="12">
            <h2>Users</h2>
          </a-col>
          <a-col :span="12" :style="{textAlign:'end'}">
            <a-button type="primary" @click="showAddModal">Add New</a-button>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24" :style="{background:'#fff'}">
            <a-table :columns="columns"
                     :loading="loading"
                     :rowKey="record => record.name"
                     :dataSource="users"
            >
              <span slot="email" slot-scope="email,record">
                <a :href="`mailto: ${record.email}`">{{ record.email }}</a>
              </span>
              <span slot="active" slot-scope="active">
                <a-tag color="#87d068" v-if="active">Active</a-tag>
                <a-tag color="#f50" v-else>Inactive</a-tag>
              </span>
              <span slot="roles" slot-scope="roles">
                <a-tag color="cyan" v-for="role in roles" :key="role.id" >
                  {{role.title}}
                </a-tag>
              </span>
              <span slot="action" slot-scope="record">
                <a-button
                  type="primary"
                  style="margin-right:5px"
                  v-if="record.active"
                  @click="showEditModal(record)"
                >Edit</a-button>
                <a-popconfirm
                  title="Are you sure delete this user?"
                  @confirm="confirmDelete(record.id)"
                  okText="Yes"
                  cancelText="No"
                >
                  <a-button v-if="record.active" type="danger">Delete</a-button>
                </a-popconfirm>
                <a-popconfirm
                  title="Are you sure restore this user?"
                  @confirm="confirmRestore(record.id)"
                  okText="Yes"
                  cancelText="No"
                >
                  <a-button v-if="!record.active" type="default">Restore</a-button>
                </a-popconfirm>
              </span>
            </a-table>
          </a-col>
        </a-row>

        <a-row>
          <div>
            <a-modal title="Edit User" :footer="null" v-model="editModalVisibility">
              <a-form :form="form" @submit.prevent="submitEditUser">
                <a-form-item label="Name" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                  <a-input v-model="user.name"/>
                </a-form-item>
                <a-form-item label="Email" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                  <a-input v-model="user.email"/>
                </a-form-item>
                <a-form-item label="Roles" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                  <a-select mode="multiple" placeholder="Select role" v-model="user.roles">
                    <a-select-option
                      v-for="role in roles"
                      :key="role.id"
                      :value="role.id"
                    >{{role.title}}</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
                  <a-button type="primary" html-type="submit">Submit</a-button>
                </a-form-item>
              </a-form>
            </a-modal>
          </div>
        </a-row>

        <a-row>
          <div>
            <a-modal title="Add User" :footer="null" v-model="addNewModalVisibility">
              <a-form :form="form" @submit.prevent="addNewUser">
                <a-form-item label="Name" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
                  <a-input placeholder="Enter your Name" v-model="user.name"/>
                </a-form-item>
                <a-form-item label="Email" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
                  <a-input placeholder="Enter Email Address" v-model="user.email"/>
                </a-form-item>
                <a-form-item label="Password" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
                  <a-input placeholder="Enter Password" type="password" v-model="user.password"/>
                </a-form-item>
                <a-form-item label="Confirm" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
                  <a-input
                    placeholder="Confirm Password"
                    type="password"
                    v-model="user.password_confirmation"
                  />
                </a-form-item>
                <a-form-item label="Roles" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
                  <a-select mode="multiple" placeholder="Select role" v-model="user.roles">
                    <a-select-option
                      v-for="role in roles"
                      :key="role.id"
                      :value="role.id"
                    >{{role.title}}</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
                  <a-button type="primary" html-type="submit">Submit</a-button>
                </a-form-item>
              </a-form>
            </a-modal>
          </div>
        </a-row>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import Sidebar from "@/components/Sidebar.vue";
import Api from "@/services/Api";
import { mapGetters } from "vuex";
const columns = [
  {
    title: "Name",
    dataIndex: "name"
  },
  {
    title: "Email",
    dataIndex: "email",
    scopedSlots: { customRender: "email" }
  },
  {
    title: "Roles",
    dataIndex: "roles",
    scopedSlots: { customRender: "roles" }
  },
  {
    title: "Status",
    dataIndex: "active",
    scopedSlots: { customRender: "active" }
  },
  {
    title: "Action",
    key: "action",
    scopedSlots: { customRender: "action" }
  }
];
export default {
  data() {
    return {
      userId: null,
      editModalVisibility: false,
      confirmLoading: false,
      addNewModalVisibility: false,
      columns,
      formLayout: "horizontal",
      form: this.$form.createForm(this),
      user: {
        id: "",
        name: "",
        email: "",
        password: "",
        password_confirmation: "",
        roles: []
      },
      loading: true
    };
  },
  components: {
    Sidebar
  },
  mounted() {
    this.form = this.$form.createForm(this);
  },
  methods: {
    showEditModal(userObj) {
      let roleIds = userObj.roles.map(item => {
        return item.id;
      });
      this.user.id = userObj.id;
      this.user.name = userObj.name;
      this.user.email = userObj.email;
      this.user.roles = roleIds;
      this.editModalVisibility = true;
    },
    showAddModal() {
      this.user.id = "";
      this.user.name = "";
      this.user.email = "";
      this.user.roles = [];
      this.addNewModalVisibility = true;
    },
    async dispatchActions() {
      this.loading = true;
      await this.$store.dispatch("users/GET_USERS", {context: this});
      await this.$store.dispatch("users/GET_ROLES", {context: this});
    },
    submitEditUser() {
      this.loading = true;
      Api.put(`wemail/users/${this.user.id}`, {
        name: this.user.name,
        email: this.user.email,
        roles: this.user.roles
      })
        .then(() => {
          this.loading = false;
          this.editModalVisibility = false;
          this.$weNotify("success", "User successfully updated!");
          this.dispatchActions();
        })
        .catch(err => this.$weNotify("error", err.response.data.message));
    },
    addNewUser() {
      this.loading = true;
      Api.post("wemail/users", {
        name: this.user.name,
        email: this.user.email,
        password: this.user.password,
        password_confirmation: this.user.password_confirmation,
        roles: this.user.roles
      })
        .then(() => {
          this.loading = false;
          this.addNewModalVisibility = false;
          this.$weNotify("success", "User successfully Created!");
          this.dispatchActions();
        })
        .catch(err => this.$weNotify("error", err.response.data.message));
    },
    confirmDelete(id) {
      Api.delete(`wemail/users/${id}`)
        .then(() => {
          this.dispatchActions();
          this.$weNotify("success", "User Successfully deleted!");
        })
        .catch(err => this.$weNotify("error", err.response.data.message));
    },
    confirmRestore(id) {
      Api.post(`wemail/users/${id}/restore`)
        .then(() => {
          this.dispatchActions();
          this.$weNotify("success", "User Successfully restored!");
        })
        .catch(err => this.$weNotify("error", err.response.data.message));
    }
  },
  created() {
    this.dispatchActions();
  },
  computed: {
    ...mapGetters({
      users: "users/users",
      roles: "users/roles"
    })
  }
};
</script>

<style>
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
  margin: 16px;
  font-size: 1.3em;
  text-align: center;
  color: #fff;
}
</style>
